import { RenderYouTubeVideo } from "@components/videos/Youtube";
import { IRaffleDefaultRewardDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import { Masks } from "@hooks/functions/Masks/Masks";
import DOMPurify from "dompurify";
import { useMemo } from "react";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

interface IProps { reward: IRaffleDefaultRewardDTO | undefined; }

const masks = new Masks();

export function RaffleDefaultNumberRewardInfo({ reward }: IProps) {
  const images = useMemo(() => {
    if (!reward) return [];
    const thumb = reward.thumb ? [{ original: reward.thumb, thumbnail: reward.thumb }] : [];
    const medias = (reward.medias || []).map((media) => media.type === "video" ? {
      original: `https://img.youtube.com/vi/${media.url}/hqdefault.jpg`,
      thumbnail: `https://img.youtube.com/vi/${media.url}/default.jpg`,
      description: media.description,
      renderItem: () => <RenderYouTubeVideo embedUrl={`https://www.youtube.com/embed/${media.url}?rel=0`} />,
    } : { original: media.url, thumbnail: media.url, description: media.description });
    return [...thumb, ...medias];
  }, [reward]);

  if (!reward) return null;

  return (
    <div className="visit-reward-detail">
      <div className="visit-reward-gallery">
        {images.length > 0 ? <ReactImageGallery key={reward.id ?? reward.order} items={images} showBullets showPlayButton={false} showFullscreenButton={false} thumbnailPosition="bottom" additionalClass="react-image-gallery-lib" /> : <div className="visit-reward-no-image">Sem imagens para este prêmio.</div>}
      </div>
      <div className="visit-reward-copy">
        <span className="visit-eyebrow">Prêmio {reward.order}</span>
        <h3>{reward.name}</h3>
        <p className="visit-muted">{reward.description_short}</p>
        <div className="visit-reward-value"><span>Valor do prêmio</span><strong>{masks.brlCurrency(reward.price)}</strong></div>
        {reward.description && <div className="visit-reward-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(reward.description) }} />}
      </div>
    </div>
  );
}
